export default __webpack_public_path__ + "static/media/desktop.e43fe9b9.jpg";